import * as Sentry from "@sentry/react";

// Initialise Sentry pour l'iframe Hexagone (meme projet que le front
// "hexagone-front"). Le DSN vient de REACT_APP_SENTRY_DSN, injecte au deploy.
// Si le DSN n'est pas defini (ex: dev local), Sentry reste inactif : aucun
// evenement n'est envoye, mais captureToSentry(...) ne casse rien.
const DSN = process.env.REACT_APP_SENTRY_DSN;

// On considere qu'on est en local quand on tourne sur localhost ou que le flag
// debug local est actif : on n'envoie pas d'evenement dans ce cas.
const isLocal =
  process.env.REACT_APP_DEBUG_DEV_LOCAL === "true" ||
  (typeof window !== "undefined" &&
    /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname));

let enabled = false;

if (DSN && !isLocal) {
  Sentry.init({
    dsn: DSN,
    environment: process.env.NODE_ENV || "production",
    // Tag tous les evenements pour les distinguer du front dans le meme projet.
    initialScope: { tags: { component: "iframe" } },
    // Traces : echantillonnage leger pour ne pas exploser le quota.
    tracesSampleRate: 0.1,
    release: process.env.REACT_APP_RELEASE || undefined,
    ignoreErrors: [
      "ResizeObserver loop limit exceeded",
      "ResizeObserver loop completed with undelivered notifications.",
    ],
  });
  enabled = true;
}

// Renseigne l'utilisateur (invite) courant sur les evenements Sentry.
export const setSentryUser = (user) => {
  if (!enabled || !user) return;
  try {
    Sentry.setUser({
      id: user.uid,
      email: user.email,
      org_id: user.org_id,
    });
  } catch (e) {
    // no-op
  }
};

// Capture une exception/erreur avec un contexte optionnel.
// Sans danger si Sentry est inactif.
export const captureToSentry = (error, context = {}) => {
  if (!enabled) return;
  try {
    Sentry.withScope((scope) => {
      if (context.tags) scope.setTags(context.tags);
      if (context.extra) scope.setContext("extra", context.extra);
      if (context.user) {
        scope.setUser({
          id: context.user.uid,
          email: context.user.email,
          org_id: context.user.org_id,
        });
      }
      if (error instanceof Error) {
        Sentry.captureException(error);
      } else {
        Sentry.captureMessage(
          typeof error === "string" ? error : JSON.stringify(error)
        );
      }
    });
  } catch (e) {
    // no-op
  }
};

export const sentryEnabled = () => enabled;

export default Sentry;
